// extracted by mini-css-extract-plugin
export default {"TabelaTitulo":"estilo_TabelaTitulo__sBEoD"};